import axios from "axios";
import Cookies from "js-cookie";
import { ID, Platform } from "models";

export const editPlatform = ({ id, platform }: { id: ID; platform: Platform }) => {
  return axios
    .put(`/api/v1/platform/${id}/`, platform, {
      headers: {
        "X-CSRFToken": Cookies.get("csrftoken"),
        "Content-Type": "application/json;charset=utf-8"
      }
    })
    .then((res) => {
      return res;
    });
};
